import {css} from 'styled-components';

const base = css`
  position: absolute;
  inset: 0;
  z-index: 5;
  background-color: ${p =>
    p.theme.id === 'light' ? 'rgba(0, 0, 0, 0.55)' : 'rgba(32, 35, 28, 0.55)'};
`;

export const web = css<{$animationDuration: number}>`
  ${base};

  opacity: 0;
  transition: opacity ${p => p.$animationDuration}ms;

  &.backdrop-appear {
    opacity: 0;
  }

  &.backdrop-appear-active {
    opacity: 1;
  }

  &.backdrop-appear-done {
    opacity: 1;
  }

  &.backdrop-exit {
    opacity: 1;
  }

  &.backdrop-exit-active {
    opacity: 0;
  }

  &.backdrop-exit-done {
    opacity: 0;
  }
`;

export const native = css`
  ${base}
`;
